import React from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import { Item } from '../../../checkout/fragments/group-items/item-list'
import TitleBox from '../../components/title-box'
import { FormattedMessage, useIntl } from 'react-intl'
import Copy from 'copy-to-clipboard';
import Toast from '../../../../../../components/toast';
import { Iconfont } from '../../../../../../components/icon/iconfont'
import { unitPrice } from '../../../../../../../utils/product'

const OrderTotal = props =>{
    const { orderTotal, shippingPrice } = props;

    return <div className={classes.OrderTotal}>
        <span><FormattedMessage id="total" defaultMessage="Total" />: </span>
        <span className={classes.Price}>{unitPrice(orderTotal)}</span>
        <span>(<span>{unitPrice(shippingPrice)}</span> <FormattedMessage id="shipping_cost" defaultMessage="shipping cost" />)</span>
    </div>
}

export default props => {
    useStyles(classes)
    const { checkoutItems, orderId } = props;
    const Intl = useIntl();

    const copyOrderId = (orderNumber) => {
        if (Copy(orderNumber)) {
            Toast(Intl.formatMessage({ id: "copy_success", defaultMessage: "Copy Success" }))
        } else {
            Toast(Intl.formatMessage({ id: "copy_fail" }))
        }
    }

    return <TitleBox
        noPadding
        extra={<Iconfont className={classes.CopyIcon} onClick={() => copyOrderId(orderId)}>&#xe776;</Iconfont>}
        title={<React.Fragment>
            <span><FormattedMessage id="order_no" defaultMessage="Order No" />: </span>
            <span className={classes.OrderNum}>{orderId}</span>
        </React.Fragment>}>
        <div className={classes.Items}>
            {
                checkoutItems?.map((item, index) => <div className={classes.Item} key={`${item.variantId}-${index}`}>
                    <Item item={{
                        ...item,
                        realPrice: item.price,
                        imageUrl: item.productImageUrl
                    }} />
                </div>)
            }
        </div>

        <OrderTotal {...props} />
    </TitleBox>
}